import React from 'react';
import { ACTIVE_META_TAGS, META_TAGS_LOOKUP, TWITTER_CARD } from '../constants';
import { buildCanonicalUrl, getMetaContent } from './index';
const renderMetaTags = (fullUrl, imageUrl, metaData, titleToUse) => ACTIVE_META_TAGS.map(tag => {
  const {
    apiKey,
    htmlTagName,
    tagKeyName,
    contentDataKeyName
  } = META_TAGS_LOOKUP[tag] || {};
  const metaExtraOptions = {
    fullUrl,
    imageUrl,
    twitterCard: TWITTER_CARD,
    titleToUse,
    canonicalUrl: buildCanonicalUrl(fullUrl)
  };
  const contentData = metaData[apiKey] || getMetaContent(apiKey, metaExtraOptions);
  return contentData && React.createElement(htmlTagName, {
    key: tag,
    [tagKeyName]: tag,
    [contentDataKeyName]: contentData
  });
});
export default renderMetaTags;
//# sourceMappingURL=render-meta-tags.js.map